import React from 'react';
import Dropzone from 'react-dropzone';
import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import ProgressBar from 'components/ProgressBar';
import { Visibility } from 'components/Visibility';
import { truncateText } from 'utils/Truncate';

const FileDropZone: React.FC<any> = (props: any) => {
  const {
    data,
    setData,
    hiddenQuestion,
    heigth,
    dontChangeColorFileName,
    backgroundColor,
    backgroundColorActive,
    accept,
    progress,
    multiple,
    messageAcceptTypes
  } = props;

  const filesType =
    accept ||
    `image/jpeg, 
    image/png,
    image/bmp,
    image/gif,
    image/vnd.microsoft.icon,
    image/webp,
    application/msword,
    application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
    application/vnd.ms-powerpoint, 
    application/vnd.openxmlformats-officedocument.presentationml.presentation, 
    application/vnd.ms-excel, 
    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
    application/xml, 
    application/pdf,
    application/vnd.visio,
    text/plain, 
    text/xml,
    text/csv,
    text/html,
    audio/mpeg,
    audio/ogg,
    audio/wav,
    audio/webm,
    audio/3gpp,
    audio/3gpp2,
    video/mpeg,
    video/ogg,
    video/x-msvideo,
    video/mp2t,
    video/webm,
    video/3gpp,
    video/3gpp2
    `;

  const maxMegaSize = 20;
  const maxSize = maxMegaSize * 1024 * 1024;

  const onDrop = (acceptedFiles: any) => {
    setData({ ...data, file: acceptedFiles[0] || undefined });
  };

  const isDragFile = (isDragActive: boolean) => {
    return !isDragActive && !data.file && !data.id;
  };

  const isFileWithUrl = () => {
    return data.file?.uri || data.file?.fileUrl;
  };

  const isFileHasNotUrl = () => {
    return (!isFileWithUrl() && (data.file?.name || data?.name));
  };

  const isDragActiveFile = (isDragActive: boolean, isDragReject: boolean) => {
    return isDragActive && !isDragReject;
  };

  const isVisibilityButtonFile = () => {
    return !data.id && !progress;
  };

  const isFileLarge = (fileRejections: any) => {
    return fileRejections.length > 0 && fileRejections[0].file.size > maxSize;
  };

  const isAlertFileLarge = (isDragActive: boolean, isFileTooLarge: boolean) => {
    return !isDragActive && isFileTooLarge;
  };

  const buttonFile = data.file?.name || data?.name ?
    'Alterar Arquivo' :
    'Selecionar Arquivo';

  return (
    <>
      {!hiddenQuestion ?? (
        <Text className="color-blue-gray mb-1" size={12}>
          Faça o upload do arquivo
        </Text>
      )}
      <Dropzone
        onDrop={onDrop}
        accept={filesType}
        minSize={0}
        maxSize={maxSize}
        disabled={data.id}
        multiple={multiple ?? true}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragReject,
          fileRejections,
        }) => {

          const isFileTooLarge = isFileLarge(fileRejections);

          return (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <Column
                className="align-center justify-center"
                style={{
                  border: '2px dashed #BEBEBE',
                  height: heigth || 250,
                  ...(isDragActive
                    ? { backgroundColor: backgroundColorActive || 'aliceblue' }
                    : { backgroundColor: backgroundColor || 'white' }),
                }}
              >
                <Visibility visible={progress > 1}>
                  <ProgressBar bgColor={'#0E4C54'} completed={progress} />
                </Visibility>

                <Visibility visible={isDragFile(isDragActive)}>
                  <Text
                    className="mt-1 font-bold"
                    size={18}
                    style={{ color: '#BEBEBE !important' }}
                  >
                    Arraste o arquivo aqui
                  </Text>
                  <Text
                    className="mt-1"
                    size={14}
                    style={{
                      color: dontChangeColorFileName || '#BEBEBE !important',
                    }}
                  >
                    ou
                  </Text>
                </Visibility>

                <Visibility visible={isFileWithUrl()}>
                  <Text
                    className="mt-1 font-bold cursor-pointer"
                    size={18}
                    style={{
                      color:
                        dontChangeColorFileName || '#BEBEBE !important',
                    }}
                  >
                    <p
                      role="presentation"
                      onClick={() =>
                        window.open(
                          data.file?.uri || data.file?.fileUrl,
                          '_blank'
                        )
                      }
                    >
                      {truncateText(data.file?.name || data?.name, 50)}
                    </p>
                  </Text>
                </Visibility>

                <Visibility visible={isFileHasNotUrl()}>
                  <Text size={14} className="m-1 font-bold">
                    {truncateText(data.file?.name || data?.name, 50)}
                  </Text>
                </Visibility>

                <Text
                  className="mt-1"
                  size={14}
                  style={{ color: '#BEBEBE !important' }}
                />

                <Visibility visible={isDragActiveFile(isDragActive, isDragReject)}>
                  <Text
                    className="mt-1 font-bold"
                    size={18}
                    style={{ color: '#BEBEBE !important' }}
                  >
                    Agora pode soltar!
                  </Text>
                  <Text
                    className="mt-1"
                    size={14}
                    style={{ color: '#BEBEBE !important' }}
                  />
                </Visibility>

                <Visibility visible={isVisibilityButtonFile()}>
                  <label
                    className={`button ${data.file?.name || data?.name ? 'outline' : 'bg-primary'
                      } mt-1`}
                  >
                    <Text
                      className={`font-bold ${data.file?.name || data?.name
                        ? 'color-primary'
                        : 'color-white'
                        }`}
                    >
                      {buttonFile}
                    </Text>
                  </label>
                </Visibility>

                <Visibility visible={messageAcceptTypes && !progress}>
                  <Text color="#F30" className="mt-3">{messageAcceptTypes}</Text>
                </Visibility>

                <Visibility visible={isDragReject}>
                  <Text className="mt-1 font-bold color-danger" size={18}>
                    Este tipo de arquivo não é permitido
                  </Text>
                </Visibility>

                <Visibility visible={isAlertFileLarge(isDragActive, isFileTooLarge)}>
                  <Text className="mt-1 font-bold color-danger" size={18}>
                    Arquivo excede o tamanho máximo de {maxMegaSize} megabytes!
                  </Text>
                </Visibility>
              </Column>
            </div>
          );
        }}
      </Dropzone>
    </>
  );
};

export default FileDropZone;
